<template src="./UserManagement.html"></template>


<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("user");
import { orderBy } from "@progress/kendo-data-query";

// import { MESSAGES } from "@/utils/constants";
// import { notify, notifyApiError } from "@/utils/notification-helper";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import CommandCell from "@/components/CommandCellTemplate";

export default {
  data: function() {
    return {
      gridData: [],
      skip: 0,
      take: 10,
      pageSize: 10,
      userId: null,
      pageable: {
        pageSizes: true,
        previousNext: true
      },
      add: true,
      search: "",
      sort: [{ field: "userName", dir: "asc" }],
      columns: [
        // { field: "id", title: "ID" },
        // { field: "name", title: "Name" },
        { field: "userName", title: "User Name" },
        { field: "email", title: "Email" },
        { field: "phoneNumber", title: "Phone Number" },
        { field: "zoneName", title: "Zone" },
        { field: "roleName", title: "Role" },
        { cell: CommandCell, title: "Actions", width: "200px" }
      ],
      dataItems: [],
      index: null
    };
  },
  methods: {
    searchEnterClicked(e) {
      this.$store.dispatch("user/searchUser", e.value).then(() => {
        this.gridData = this.$store.getters["user/userList"];
      });
    },
    openWindow: function() {
      this.$router.push({
        name: "AddUser",
        params: { add: true }
      });
    },
    exportExcel() {
      saveExcel({
        data: this.userList,
        fileName: "Users",
        columns: [
          { field: "id", title: "ID" },
          { field: "name", title: "Name" },
          { field: "email", title: "Email" },
          { field: "userName", title: "User Name" },
          { field: "phoneNumber", title: "Phone Number" },
          { field: "zoneName", title: "Zone" },
          { field: "roleName", title: "Role" }
        ]
      });
    },
    async getDataOnload() {
      this.$store.dispatch("user/userList");
    },
    edit: function(item) {
      return this.$store.dispatch("user/editUser", item.dataItem);
    },
    remove: function(item) {
      return this.$store.dispatch("user/removeUser", item.dataItem).then(() => {
        // notify(MESSAGES.CHANGES_SAVE_SUCCESS);
      });
      // .catch(notifyApiError);
    },
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    }
  },
  computed: {
    ...mapState({
      userList: state => state.user
    }),
    total() {
      return this.userList ? this.userList.length : 0;
    },
    items: {
      get: function() {
        return orderBy(
          this.userList.slice(this.skip, this.take + this.skip),this.sort);
      }
    },
    filter() {
      return {
        logic: "or",
        filters: [
          { field: "userName", operator: "contains", value: this.search },
          { field: "phoneNumber ", operator: "contains", value: this.search }
        ]
      };
    }
  },

  created: function() {
    this.getDataOnload();
  }
};
</script>
